module.exports = "/static/assets/4561a51c20e7ea23d6eba9b68f179420.png";